import { render, staticRenderFns } from "./transformer-manage.vue?vue&type=template&id=68299da4&"
import script from "./transformer-manage.vue?vue&type=script&lang=js&"
export * from "./transformer-manage.vue?vue&type=script&lang=js&"
import style0 from "./transformer-manage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports